import React from 'react'
import { utils, CardContainer, LabelValue, constants } from '@adc/ui-core'
import type {
  OnlineAuctionSegment,
  OnlineAuctionSegmentBid,
} from '@adc/sdk/types'
import classnames from 'classnames/bind'
import _ from 'lodash'
import cls from './styles.scss'
import OfferChart from '../offerChart'

const cx = classnames.bind(cls)
const { ColorNames } = constants

type Summary = {
  label: string
  value: number | string | undefined | null
  isCurrency: boolean
}

type OfferSummaryHeaderProps = {
  summary: Summary[]
  elmId?: string
  className?: string
  showChart?: boolean
  bid: OnlineAuctionSegmentBid
  segment?: OnlineAuctionSegment
}

const OfferSummaryHeader = ({
  showChart = true,
  className,
  elmId = '',
  bid,
  segment,
}: OfferSummaryHeaderProps) => {
  const summary = [
    {
      label: 'Closing Date',
      value: bid.terms?.close_escrow_duration,
      isCurrency: false,
      postfix: ' Days from Contract Execution',
    },
    {
      label: 'Down Payment',
      value: bid.terms?.down_payment_amount,
      isCurrency: true,
    },
    {
      label: 'Earnest Money Deposit',
      value: bid.terms?.earnest_money_deposit_amount,
      isCurrency: true,
    },
  ]

  const displayValue = (result: Summary, isCurrency = false): string => {
    const stringDefaultValue = `--`
    const numberDefaultValue = `$0`
    const value = isCurrency
      ? // @ts-ignore next
        utils?.formatters?.formatMoney?.(result.value) || numberDefaultValue
      : result.value

    return String(value ?? stringDefaultValue)
  }

  return (
    <CardContainer
      className={cx('summary-container', className)}
      elmId={`${elmId}_summary_container`}
      padding='none'
      borderColor={ColorNames.GrayLight}
      borderStyle='none'
      borderRadius='medium'
      borderRadiusCorners='top'
      dropShadow='none'
      backgroundColor={ColorNames.White}
    >
      <div className={cx('summary-result-container')}>
        {_.map(summary, (result, index) => (
          <div
            data-elm-id={`${elmId}_summary_result_${index}`}
            className={cx('summary-result-container-item')}
            key={index}
          >
            <LabelValue
              value={`${displayValue(result, result.isCurrency)}${
                result.postfix ?? ''
              }`}
              label={result.label}
              // @ts-ignore something with types
              level={5}
            />
          </div>
        ))}
      </div>
      {showChart && (
        <div data-elm-id={`${elmId}_chart_container`}>
          <OfferChart segment={segment} />
        </div>
      )}
    </CardContainer>
  )
}

export default OfferSummaryHeader
